import { render } from "./Places.vue?vue&type=template&id=51ac0dc8&ts=true"
import script from "./Places.vue?vue&type=script&lang=ts"
export * from "./Places.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__